const backdropContrast = {
    name: "backdrop-contrast",
    path: "/backdrop-contrast",
    title: "backdrop-contrast",
    description: "Utilities for applying backdrop-contrast filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-contrast-<number>': 'contrast(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-contrast-50, backdrop-contrast-100",
            "description": "to control an element's backdrop-contrast:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-contrast-50",
                        "text": "backdrop-contrast-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                         "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-contrast-100",
                        "text": "backdrop-contrast-100",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-contrast-125",
                        "text": "backdrop-contrast-125",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-contrast-200",
                        "text": "backdrop-contrast-200",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-contrast-50" src="/img/mountains.jpg" />
<img class="backdrop-contrast-100" src="/img/mountains.jpg" />
<img class="backdrop-contrast-125" src="/img/mountains.jpg" />
<img class="backdrop-contrast-200" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropContrast;